import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import RoundButton from '../../common/RoundButton';
import { CAMP_KID_ACTIVITIES, CAMP_REASSIGN_KID, SCHOOL_KIDS_ROUTE } from '../../../constants/routes.constants';
import { settingsViewModel } from '../dashboard/settings.view.model';
import { useAuth } from '../../auth/Auth';
import CampDisconnectModal from './CampDisconnectModal';

const KidInsightsActionButtons = ({ dependent }) => {
  const history = useHistory();
  const { school } = useAuth();
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);

  const handleCloseDeleteConfirm = () => setShowDeleteConfirm(false);

  const disConnectTreehouse = () => {
    let params = {
      dependent_id: dependent?.id,
      treehouse_id: dependent?.profile?.group.id
    }
    settingsViewModel.disConnectTreehouse(params).then((res) => {
      setShowDeleteConfirm(false);
      history.push(SCHOOL_KIDS_ROUTE);
    }).catch((err) => {
      console.log(err)
    })
  }

  const handleReassign = () => {
    history.push({
      pathname: CAMP_REASSIGN_KID,
      state: { dependent_id: dependent?.id, dependent_username: dependent?.username, group_id: dependent?.profile?.group?.id }
    })
  }

  const handleActivity = () => {
    history.push({
      pathname: CAMP_KID_ACTIVITIES,
      state: { dependent: JSON.stringify(dependent) }
    })
  }

  return (
    <div className="button-wrapper">
      <RoundButton
        type="button"
        label={`${dependent?.username}'s Activities`}
        className="edit-button button"
        onClick={handleActivity}
      />
      {school?.user_type === "school" &&
        <>
          <RoundButton
            type="button"
            label={`Reassign ${dependent?.username}`}
            className="edit-button button"
            onClick={handleReassign}
          />
          <RoundButton
            type="button"
            label="Disconnect camp"
            className="disc-scl-btn button"
            onClick={() =>
              setShowDeleteConfirm(true)
            }
          />
        </>
      }
      {showDeleteConfirm && <CampDisconnectModal showModal={showDeleteConfirm} setShowModal={setShowDeleteConfirm} handleDisconnect={disConnectTreehouse} username={dependent?.username} />}
    </div>
  );
};

export default KidInsightsActionButtons;
